import { createFileRoute, Outlet, useNavigate, useLocation } from "@tanstack/react-router";
import { useEffect } from "react";
import { useAuth } from "@/hooks/use-auth";

export const Route = createFileRoute("/_authenticated")({
  component: AuthGuard,
});

function AuthGuard() {
  const { user, loading } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (!loading && !user) {
      if (location.pathname === "/login") return;
      const isAdmin = location.pathname.startsWith("/app/admin");
      const redirectTarget = location.href || location.pathname;
      navigate({
        to: "/login",
        replace: true,
        search: {
          redirect: redirectTarget,
          ...(isAdmin ? { context: "admin" } : {}),
        } as never,
      });
    }
  }, [user, loading, navigate, location.pathname, location.href]);

  if (loading || !user) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="size-12 rounded-full border-4 border-clay border-t-primary animate-spin" />
      </div>
    );
  }

  return <Outlet />;
}
